import React from 'react';
import MainBody from '../templates/MainBody';
import { socmintContent, socmintInvestigationQuestions } from '../data';

const SOCMINT: React.FC = () => {
  return <MainBody data={socmintContent} investigationQuestions={socmintInvestigationQuestions} />
};

export default SOCMINT;